"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundTaskType = exports.InboundTaskStatus = void 0;
var InboundTaskStatus;
(function (InboundTaskStatus) {
    InboundTaskStatus["NEEDS_ACTION"] = "NEEDS_ACTION";
    InboundTaskStatus["COMPLETED"] = "COMPLETED";
})(InboundTaskStatus = exports.InboundTaskStatus || (exports.InboundTaskStatus = {}));
var InboundTaskType;
(function (InboundTaskType) {
    InboundTaskType["ADD_PRODUCTS"] = "ADD_PRODUCTS";
    InboundTaskType["ADD_CASEPACKS"] = "ADD_CASEPACKS";
    InboundTaskType["UPLOAD_FBA_LABELS"] = "UPLOAD_FBA_LABELS";
    InboundTaskType["UPDATE_FBA_REFERENCE_ID"] = "UPDATE_FBA_REFERENCE_ID";
    InboundTaskType["LINK_FBA_ACCOUNT"] = "LINK_FBA_ACCOUNT";
    InboundTaskType["ADD_PRODUCTS_AND_BOX_CONFIGURATIONS"] = "ADD_PRODUCTS_AND_BOX_CONFIGURATIONS";
    InboundTaskType["ADD_BARCODES"] = "ADD_BARCODES";
    InboundTaskType["REVIEW_PACKAGING_REQUIREMENTS"] = "REVIEW_PACKAGING_REQUIREMENTS";
    InboundTaskType["DOWNLOAD_BOX_CONTENT_LABELS"] = "DOWNLOAD_BOX_CONTENT_LABELS";
    InboundTaskType["ADD_LOT_TRACKING_DETAILS"] = "ADD_LOT_TRACKING_DETAILS";
    InboundTaskType["ADD_HTS_CODE"] = "ADD_HTS_CODE";
    InboundTaskType["ADD_PRODUCTS_AND_UNITS"] = "ADD_PRODUCTS_AND_UNITS";
})(InboundTaskType = exports.InboundTaskType || (exports.InboundTaskType = {}));
//# sourceMappingURL=InboundTask.js.map